<script>
  export let data;
  export let index;
  export let active;
  export let matchingOutcomes;
  export let searchIsEntered;
  export let isHidden;
  export let isScrollytelling;

  import {
    topFourDepartments,
    selectedPerformanceMeasures,
  } from "@stores/userData.js";

  $: isSelected = false;

  $: checkIsSelected = function () {
    isSelected = $selectedPerformanceMeasures
      .map((d) => d.Measure)
      .includes(data.Measure);
  };

  $: $selectedPerformanceMeasures.length, checkIsSelected();
  $: currentMeasures = $selectedPerformanceMeasures;

  $: isInTopFour = $topFourDepartments
    .map((d) => d.Department)
    .includes(data.Department);

  $: isInSearchQuery =
    matchingOutcomes &&
    matchingOutcomes.map((d) => d.Measure).includes(data.Measure);

  $: anyAreSelected = $selectedPerformanceMeasures.length > 0;

  $: addOrRemoveMeasure = function (measure) {
    if (currentMeasures.map((d) => d.Measure).includes(measure)) {
      currentMeasures = currentMeasures
        .slice()
        .filter((d) => d.Measure != measure);
    } else {
      // If selectedPerformanceMeasures doesn't include data, add it
      currentMeasures = [...currentMeasures, data];
    }
    selectedPerformanceMeasures.set(currentMeasures);
  };

  import touchscreen from "@stores/touchscreen.js";
</script>

<!-- MINOR FIXME: Clean this up. There is so much going on here something could easily go wrong -->
<button
  tabindex={isScrollytelling ? -1 : 0}
  class="rect event-listener"
  style="transition: opacity 200ms ease {index * 30}ms;"
  class:isHidden
  class:unhoverable={isScrollytelling && !isInTopFour}
  class:active={active?.Measure == data.Measure ||
    (!isScrollytelling && isSelected)}
  class:inactive={(isScrollytelling && !isInTopFour) ||
    (((searchIsEntered && !isInSearchQuery) || !searchIsEntered) &&
      !isScrollytelling &&
      anyAreSelected &&
      !isSelected &&
      active?.Measure != data.Measure)}
  class:disableInteraction={isScrollytelling && !isInTopFour}
  class:searched={searchIsEntered && isInSearchQuery}
  on:click={() => {
    if ($touchscreen) {
      if (isScrollytelling & !isInTopFour) return;
      active = data;
    } else {
      if (isScrollytelling) return;
      addOrRemoveMeasure(data.Measure);
    }
  }}
  on:focus={() => {
    if (isScrollytelling & !isInTopFour) return;
    active = data;
  }}
  on:mouseover={() => {
    if (isScrollytelling & !isInTopFour) return;
    active = data;
  }}
  on:mouseleave={(e) => {
    if ($touchscreen) {
      e.preventDefault();
    }
  }}
/>

<style>
  .event-listener {
    position: relative;
    cursor: pointer;
    user-select: none;
    z-index: 101; /* Above click-out listener so user can click around while one is open */
  }
  .rect {
    display: inline-block;
    width: 13px;
    height: 13px;
    background: var(--accent-color);
    /* outline: 1px solid black; */
    outline: 1px solid transparent;
    margin-right: 2px;
    margin-bottom: 2px;
    transition: opacity 300ms ease, background 300ms ease;
  }

  .rect:hover {
    outline: 1px solid black;
  }

  .rect.active {
    outline: 1px solid black;
  }

  .rect.inactive {
    opacity: 0.5;
    outline: 1px solid transparent;
  }

  .rect.unhoverable {
    cursor: none;
    pointer-events: none;
  }

  .isHidden {
    opacity: 0;
    pointer-events: none;
    cursor: default;
  }

  .searched {
    background: #ffc126;
  }

  .disableInteraction {
    pointer-events: none;
  }
</style>
